export const BrandHubConfig = {
  CREATIVES_PAGE_SIZE: 9,
};
